import React, { useState, useEffect } from 'react';
import { integrationDocsUrl } from '../../utils/integrationDocs';
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import axiosInstance from '../api';
import './VendorOverviewPage.css';

const SI   = 'https://cdn.simpleicons.org';
const WIKI = 'https://upload.wikimedia.org/wikipedia/commons';
/* Clearbit Logo API — brand logos by domain, for vendors Simple Icons dropped for trademark. */
const CB   = (domain) => `https://www.google.com/s2/favicons?sz=64&domain=${domain}`;

const VENDOR_LOGOS = {
  aws:           'https://aws.amazon.com/favicon.ico',
  gcp:           `${WIKI}/5/51/Google_Cloud_logo.svg`,
  azure:         `${WIKI}/f/fa/Microsoft_Azure.svg`,
  github:        `${SI}/github/181717`,
  jira:          `${SI}/jira/0052CC`,
  gitlab:        `${SI}/gitlab/FC6D26`,
  kubernetes:    `${SI}/kubernetes/326CE5`,
  datadog:       `${SI}/datadog/632CA6`,
  okta:          `${SI}/okta/007DC1`,
  googleworkspace: `${SI}/google/4285F4`,
  onelogin:      CB('onelogin.com'),
  jumpcloud:     CB('jumpcloud.com'),
  duo:           CB('duo.com'),
  pingone:       CB('pingidentity.com'),
  auth0:         `${SI}/auth0/EB5424`,
  clerk:         `${SI}/clerk/6C47FF`,
  postmark:      CB('postmarkapp.com'),
  jamf:          CB('jamf.com'),
  intune:        CB('microsoft.com'),
  kandji:        CB('kandji.io'),
  snowflake:     `${SI}/snowflake/29B5E8`,
  splunk:        `${SI}/splunk/000000`,
  pagerduty:     `${SI}/pagerduty/06AC38`,
  bitbucket:     `${SI}/bitbucket/0052CC`,
  digitalocean:  `${SI}/digitalocean/0080FF`,
  newrelic:      `${SI}/newrelic/008C99`,
  cloudflare:    `${SI}/cloudflare/F38020`,
  sentry:        `${SI}/sentry/362D59`,
  microsoft:     `${WIKI}/4/44/Microsoft_logo.svg`,
  /* ---- catalog evidence vendor logos (Clearbit; onError → letter-tile) ---- */
  "ascend": "https://www.google.com/s2/favicons?sz=64&domain=ascend.com",
  "assurancelab": "https://www.google.com/s2/favicons?sz=64&domain=assurancelab.com",
  "audora": "https://www.google.com/s2/favicons?sz=64&domain=audora.com",
  "fieldguide": "https://www.google.com/s2/favicons?sz=64&domain=fieldguide.com",
  "trenta": "https://www.google.com/s2/favicons?sz=64&domain=trenta.com",
  "certn": "https://www.google.com/s2/favicons?sz=64&domain=certn.com",
  "checkr": "https://www.google.com/s2/favicons?sz=64&domain=checkr.com",
  "hirepass": "https://www.google.com/s2/favicons?sz=64&domain=hirepass.com",
  "veremark": "https://www.google.com/s2/favicons?sz=64&domain=veremark.com",
  "vetty": "https://www.google.com/s2/favicons?sz=64&domain=vetty.com",
  "zinc": "https://www.google.com/s2/favicons?sz=64&domain=zinc.com",
  "capsule": "https://www.google.com/s2/favicons?sz=64&domain=capsule.com",
  "close": "https://www.google.com/s2/favicons?sz=64&domain=close.com",
  "copper": "https://www.google.com/s2/favicons?sz=64&domain=copper.com",
  "hubspot": "https://www.google.com/s2/favicons?sz=64&domain=hubspot.com",
  "insightly": "https://www.google.com/s2/favicons?sz=64&domain=insightly.com",
  "salesforce": "https://www.google.com/s2/favicons?sz=64&domain=salesforce.com",
  "zendesk": "https://www.google.com/s2/favicons?sz=64&domain=zendesk.com",
  "amazonecr": "https://www.google.com/s2/favicons?sz=64&domain=aws.amazon.com",
  "awsgovcloud": "https://www.google.com/s2/favicons?sz=64&domain=aws.amazon.com",
  "digitaloceanspaces": "https://www.google.com/s2/favicons?sz=64&domain=digitalocean.com",
  "gcpartifact": "https://www.google.com/s2/favicons?sz=64&domain=cloud.google.com",
  "grafanacloud": "https://www.google.com/s2/favicons?sz=64&domain=grafana.com",
  "heroku": "https://www.google.com/s2/favicons?sz=64&domain=heroku.com",
  "netlify": "https://www.google.com/s2/favicons?sz=64&domain=netlify.com",
  "oci": "https://www.google.com/s2/favicons?sz=64&domain=oracle.com",
  "ovhcloud": "https://www.google.com/s2/favicons?sz=64&domain=ovhcloud.com",
  "railway": "https://www.google.com/s2/favicons?sz=64&domain=railway.app",
  "render": "https://www.google.com/s2/favicons?sz=64&domain=render.com",
  "scaleway": "https://www.google.com/s2/favicons?sz=64&domain=scaleway.com",
  vercel:        `${SI}/vercel/000000`,
  "intercom": "https://www.google.com/s2/favicons?sz=64&domain=intercom.com",
  "zoom": "https://www.google.com/s2/favicons?sz=64&domain=zoom.us",
  "databricks": "https://www.google.com/s2/favicons?sz=64&domain=databricks.com",
  "mongoatlas": "https://www.google.com/s2/favicons?sz=64&domain=mongodb.com",
  "box": "https://www.google.com/s2/favicons?sz=64&domain=box.com",
  "dropbox": "https://www.google.com/s2/favicons?sz=64&domain=dropbox.com",
  "googledrive": "https://www.google.com/s2/favicons?sz=64&domain=google.com",
  "guru": "https://www.google.com/s2/favicons?sz=64&domain=guru.com",
  "microsoftsharepoint": "https://www.google.com/s2/favicons?sz=64&domain=microsoft.com",
  "notion": "https://www.google.com/s2/favicons?sz=64&domain=notion.so",
  "pima": "https://www.google.com/s2/favicons?sz=64&domain=pima.com",
  "agency": "https://www.google.com/s2/favicons?sz=64&domain=agency.com",
  "automox": "https://www.google.com/s2/favicons?sz=64&domain=automox.com",
  "hexnode": "https://www.google.com/s2/favicons?sz=64&domain=hexnode.com",
  "kitecyber": "https://www.google.com/s2/favicons?sz=64&domain=kitecyber.com",
  "7shifts": "https://www.google.com/s2/favicons?sz=64&domain=7shifts.com",
  "adpworkforce": "https://www.google.com/s2/favicons?sz=64&domain=adp.com",
  "alexishr": "https://www.google.com/s2/favicons?sz=64&domain=alexishr.com",
  "alterapayroll": "https://www.google.com/s2/favicons?sz=64&domain=alterapayroll.com",
  "bamboohr": "https://www.google.com/s2/favicons?sz=64&domain=bamboohr.com",
  "bob": "https://www.google.com/s2/favicons?sz=64&domain=bob.com",
  "breathe": "https://www.google.com/s2/favicons?sz=64&domain=breathe.com",
  "breezyhr": "https://www.google.com/s2/favicons?sz=64&domain=breezyhr.com",
  "breezyhrx": "https://www.google.com/s2/favicons?sz=64&domain=breezyhr.com",
  "central": "https://www.google.com/s2/favicons?sz=64&domain=central.com",
  "dayforce": "https://www.google.com/s2/favicons?sz=64&domain=dayforce.com",
  "charliehr": "https://www.google.com/s2/favicons?sz=64&domain=charliehr.com",
  "clayhr": "https://www.google.com/s2/favicons?sz=64&domain=clayhr.com",
  "cyberark": "https://www.google.com/s2/favicons?sz=64&domain=cyberark.com",
  "deel": "https://www.google.com/s2/favicons?sz=64&domain=deel.com",
  "employmenthero": "https://www.google.com/s2/favicons?sz=64&domain=employmenthero.com",
  "factorial": "https://www.google.com/s2/favicons?sz=64&domain=factorial.com",
  "freshteam": "https://www.google.com/s2/favicons?sz=64&domain=freshworks.com",
  "gusto": "https://www.google.com/s2/favicons?sz=64&domain=gusto.com",
  "hrcloud": "https://www.google.com/s2/favicons?sz=64&domain=hrcloud.com",
  "hrpartner": "https://www.google.com/s2/favicons?sz=64&domain=hrpartner.com",
  "humaans": "https://www.google.com/s2/favicons?sz=64&domain=humaans.com",
  "insperity": "https://www.google.com/s2/favicons?sz=64&domain=insperity.com",
  "intellihr": "https://www.google.com/s2/favicons?sz=64&domain=intellihr.com",
  "isolved": "https://www.google.com/s2/favicons?sz=64&domain=isolved.com",
  "justworks": "https://www.google.com/s2/favicons?sz=64&domain=justworks.com",
  "kallidus": "https://www.google.com/s2/favicons?sz=64&domain=kallidus.com",
  "keka": "https://www.google.com/s2/favicons?sz=64&domain=keka.com",
  "kenjo": "https://www.google.com/s2/favicons?sz=64&domain=kenjo.com",
  "lano": "https://www.google.com/s2/favicons?sz=64&domain=lano.com",
  "lucca": "https://www.google.com/s2/favicons?sz=64&domain=lucca.fr",
  "namely": "https://www.google.com/s2/favicons?sz=64&domain=namely.com",
  "netsuite": "https://www.google.com/s2/favicons?sz=64&domain=netsuite.com",
  "nmbrs": "https://www.google.com/s2/favicons?sz=64&domain=nmbrs.com",
  "officient": "https://www.google.com/s2/favicons?sz=64&domain=officient.com",
  "oraclecloudhcm": "https://www.google.com/s2/favicons?sz=64&domain=oracle.com",
  "oyster": "https://www.google.com/s2/favicons?sz=64&domain=oysterhr.com",
  "paycaptain": "https://www.google.com/s2/favicons?sz=64&domain=paycaptain.com",
  "paychexflex": "https://www.google.com/s2/favicons?sz=64&domain=paychex.com",
  "paycor": "https://www.google.com/s2/favicons?sz=64&domain=paycor.com",
  "payfit95f52": "https://www.google.com/s2/favicons?sz=64&domain=payfit.com",
  "paylocity": "https://www.google.com/s2/favicons?sz=64&domain=paylocity.com",
  "payworks": "https://www.google.com/s2/favicons?sz=64&domain=payworks.com",
  "peoplehr": "https://www.google.com/s2/favicons?sz=64&domain=peoplehr.com",
  "personio": "https://www.google.com/s2/favicons?sz=64&domain=personio.com",
  "proliant": "https://www.google.com/s2/favicons?sz=64&domain=proliant.com",
  "quickbooks": "https://www.google.com/s2/favicons?sz=64&domain=intuit.com",
  "remote": "https://www.google.com/s2/favicons?sz=64&domain=remote.com",
  "rippling": "https://www.google.com/s2/favicons?sz=64&domain=rippling.com",
  "sage": "https://www.google.com/s2/favicons?sz=64&domain=sage.com",
  "sagehr": "https://www.google.com/s2/favicons?sz=64&domain=sage.com",
  "sapsuccessfactors": "https://www.google.com/s2/favicons?sz=64&domain=sap.com",
  "sesame": "https://www.google.com/s2/favicons?sz=64&domain=sesame.com",
  "squarepayrollf5639": "https://www.google.com/s2/favicons?sz=64&domain=squarepayroll.com",
  "torii": "https://www.google.com/s2/favicons?sz=64&domain=torii.com",
  "trinet": "https://www.google.com/s2/favicons?sz=64&domain=trinet.com",
  "ukgdimensions": "https://www.google.com/s2/favicons?sz=64&domain=ukg.com",
  "ukgpro": "https://www.google.com/s2/favicons?sz=64&domain=ukg.com",
  "ukgready": "https://www.google.com/s2/favicons?sz=64&domain=ukg.com",
  "workable": "https://www.google.com/s2/favicons?sz=64&domain=workable.com",
  "workday": "https://www.google.com/s2/favicons?sz=64&domain=workday.com",
  "zenefits": "https://www.google.com/s2/favicons?sz=64&domain=zenefits.com",
  "azuread": "https://www.google.com/s2/favicons?sz=64&domain=microsoft.com",
  "office365": "https://www.google.com/s2/favicons?sz=64&domain=microsoft.com",
  "entragcchigh": "https://www.google.com/s2/favicons?sz=64&domain=microsoft.com",
  "sclaeai": "https://www.google.com/s2/favicons?sz=64&domain=scale.com",
  "breachrx": "https://www.google.com/s2/favicons?sz=64&domain=breachrx.com",
  "incident": "https://www.google.com/s2/favicons?sz=64&domain=incident.io",
  "addigy": "https://www.google.com/s2/favicons?sz=64&domain=addigy.com",
  "datto": "https://www.google.com/s2/favicons?sz=64&domain=datto.com",
  "edamametechnologies": "https://www.google.com/s2/favicons?sz=64&domain=edamame.technology",
  "fleet": "https://www.google.com/s2/favicons?sz=64&domain=fleetdm.com",
  "microsoftintune": "https://www.google.com/s2/favicons?sz=64&domain=microsoft.com",
  "iru": "https://www.google.com/s2/favicons?sz=64&domain=iru.com",
  "kolide": "https://www.google.com/s2/favicons?sz=64&domain=kolide.com",
  "manageengine": "https://www.google.com/s2/favicons?sz=64&domain=manageengine.com",
  "microsoftendpointmanager": "https://www.google.com/s2/favicons?sz=64&domain=microsoft.com",
  "intunegcchigh": "https://www.google.com/s2/favicons?sz=64&domain=microsoft.com",
  "miradore": "https://www.google.com/s2/favicons?sz=64&domain=miradore.com",
  "ninjaone": "https://www.google.com/s2/favicons?sz=64&domain=ninjaone.com",
  "omnissa": "https://www.google.com/s2/favicons?sz=64&domain=omnissa.com",
  "primo": "https://www.google.com/s2/favicons?sz=64&domain=primo.com",
  "simplemdm": "https://www.google.com/s2/favicons?sz=64&domain=simplemdm.com",
  "swif": "https://www.google.com/s2/favicons?sz=64&domain=swif.com",
  "trio": "https://www.google.com/s2/favicons?sz=64&domain=trio.com",
  "vmwareworkspaceone": "https://www.google.com/s2/favicons?sz=64&domain=vmware.com",
  "xcitium": "https://www.google.com/s2/favicons?sz=64&domain=xcitium.com",
  "xfa": "https://www.google.com/s2/favicons?sz=64&domain=xfa.com",
  "sumologic": "https://www.google.com/s2/favicons?sz=64&domain=sumologic.com",
  "1password": "https://www.google.com/s2/favicons?sz=64&domain=1password.com",
  "4me": "https://www.google.com/s2/favicons?sz=64&domain=4me.com",
  "8x8": "https://www.google.com/s2/favicons?sz=64&domain=8x8.com",
  "abv": "https://www.google.com/s2/favicons?sz=64&domain=abv.com",
  "accessowl": "https://www.google.com/s2/favicons?sz=64&domain=accessowl.com",
  "acunetix360": "https://www.google.com/s2/favicons?sz=64&domain=acunetix360.com",
  "adobelearning": "https://www.google.com/s2/favicons?sz=64&domain=adobelearningmanager.com",
  "airtable": "https://www.google.com/s2/favicons?sz=64&domain=airtable.com",
  "akamai": "https://www.google.com/s2/favicons?sz=64&domain=akamai.com",
  "alertmedia": "https://www.google.com/s2/favicons?sz=64&domain=alertmedia.com",
  "amplitude": "https://www.google.com/s2/favicons?sz=64&domain=amplitude.com",
  "anthropic": "https://www.google.com/s2/favicons?sz=64&domain=anthropic.com",
  "apollo": "https://www.google.com/s2/favicons?sz=64&domain=apollo.com",
  "appaegis76b4c": "https://www.google.com/s2/favicons?sz=64&domain=appaegis.com",
  "applebusinessmanager": "https://www.google.com/s2/favicons?sz=64&domain=apple.com",
  "appranix": "https://www.google.com/s2/favicons?sz=64&domain=appranix.com",
  "ashby": "https://www.google.com/s2/favicons?sz=64&domain=ashbyhq.com",
  "assetpanda": "https://www.google.com/s2/favicons?sz=64&domain=assetpanda.com",
  "axisatmos": "https://www.google.com/s2/favicons?sz=64&domain=atmos.com",
  "autodesk": "https://www.google.com/s2/favicons?sz=64&domain=autodesk.com",
  "azuresynapse": "https://www.google.com/s2/favicons?sz=64&domain=microsoft.com",
  "bis": "https://www.google.com/s2/favicons?sz=64&domain=bis.com",
  "bitwarden": "https://www.google.com/s2/favicons?sz=64&domain=bitwarden.com",
  "blink": "https://www.google.com/s2/favicons?sz=64&domain=blink.com",
  "blinq": "https://www.google.com/s2/favicons?sz=64&domain=blinq.com",
  "blogin": "https://www.google.com/s2/favicons?sz=64&domain=blogin.com",
  "bluejeans": "https://www.google.com/s2/favicons?sz=64&domain=bluejeans.com",
  "bocada": "https://www.google.com/s2/favicons?sz=64&domain=bocada.com",
  "brex": "https://www.google.com/s2/favicons?sz=64&domain=brex.com",
  "britive": "https://www.google.com/s2/favicons?sz=64&domain=britive.com",
  "browserstack": "https://www.google.com/s2/favicons?sz=64&domain=browserstack.com",
  "calendly": "https://www.google.com/s2/favicons?sz=64&domain=calendly.com",
  "cats": "https://www.google.com/s2/favicons?sz=64&domain=cats.com",
  "charthop": "https://www.google.com/s2/favicons?sz=64&domain=charthop.com",
  "checkproof": "https://www.google.com/s2/favicons?sz=64&domain=checkproof.com",
  "cinode": "https://www.google.com/s2/favicons?sz=64&domain=cinode.com",
  "cleanmailf734a": "https://www.google.com/s2/favicons?sz=64&domain=cleanmail.com",
  "clebex": "https://www.google.com/s2/favicons?sz=64&domain=clebex.com",
  "clockworkrecruiter": "https://www.google.com/s2/favicons?sz=64&domain=clockworkrecruiting.com",
  "cloudback": "https://www.google.com/s2/favicons?sz=64&domain=cloudback.com",
  "coda": "https://www.google.com/s2/favicons?sz=64&domain=coda.com",
  "comeet": "https://www.google.com/s2/favicons?sz=64&domain=comeet.com",
  "commonpaper": "https://www.google.com/s2/favicons?sz=64&domain=commonpaper.com",
  "confluence": "https://www.google.com/s2/favicons?sz=64&domain=atlassian.com",
  "contentful": "https://www.google.com/s2/favicons?sz=64&domain=contentful.com",
  "continuitystrength": "https://www.google.com/s2/favicons?sz=64&domain=continuitystrength.com",
  "cside": "https://www.google.com/s2/favicons?sz=64&domain=cside.com",
  "cybsafe": "https://www.google.com/s2/favicons?sz=64&domain=cybsafe.com",
  "dashlane": "https://www.google.com/s2/favicons?sz=64&domain=dashlane.com",
  "dbtlab": "https://www.google.com/s2/favicons?sz=64&domain=dbtlabs.com",
  "dockerhub": "https://www.google.com/s2/favicons?sz=64&domain=docker.com",
  "documo": "https://www.google.com/s2/favicons?sz=64&domain=documo.com",
  "docusign": "https://www.google.com/s2/favicons?sz=64&domain=docusign.com",
  "doppler": "https://www.google.com/s2/favicons?sz=64&domain=doppler.com",
  "drift": "https://www.google.com/s2/favicons?sz=64&domain=drift.com",
  "dynatrace": "https://www.google.com/s2/favicons?sz=64&domain=dynatrace.com",
  "elastic": "https://www.google.com/s2/favicons?sz=64&domain=elastic.co",
  "eletive": "https://www.google.com/s2/favicons?sz=64&domain=eletive.com",
  "elium": "https://www.google.com/s2/favicons?sz=64&domain=elium.com",
  "envkey": "https://www.google.com/s2/favicons?sz=64&domain=envkey.com",
  "envoy": "https://www.google.com/s2/favicons?sz=64&domain=envoy.com",
  "evervault": "https://www.google.com/s2/favicons?sz=64&domain=evervault.com",
  "exium": "https://www.google.com/s2/favicons?sz=64&domain=exium.com",
  "faceup": "https://www.google.com/s2/favicons?sz=64&domain=faceup.com",
  "figma": "https://www.google.com/s2/favicons?sz=64&domain=figma.com",
  "fivetran": "https://www.google.com/s2/favicons?sz=64&domain=fivetran.com",
  "flock": "https://www.google.com/s2/favicons?sz=64&domain=flock.com",
  "foodee": "https://www.google.com/s2/favicons?sz=64&domain=foodee.com",
  "fourfour": "https://www.google.com/s2/favicons?sz=64&domain=fourfour.com",
  "gdprlocal": "https://www.google.com/s2/favicons?sz=64&domain=gdprlocal.com",
  "ghostable": "https://www.google.com/s2/favicons?sz=64&domain=ghostable.com",
  "gong": "https://www.google.com/s2/favicons?sz=64&domain=gong.com",
  "grammarly": "https://www.google.com/s2/favicons?sz=64&domain=grammarly.com",
  "greenhouse": "https://www.google.com/s2/favicons?sz=64&domain=greenhouse.io",
  "griffo": "https://www.google.com/s2/favicons?sz=64&domain=griffo.com",
  "h5mag": "https://www.google.com/s2/favicons?sz=64&domain=h5mag.com",
  "harness": "https://www.google.com/s2/favicons?sz=64&domain=harness.io",
  "harvest": "https://www.google.com/s2/favicons?sz=64&domain=harvest.com",
  "helloid": "https://www.google.com/s2/favicons?sz=64&domain=helloid.com",
  "hootsuite": "https://www.google.com/s2/favicons?sz=64&domain=hootsuite.com",
  "hoxhunt": "https://www.google.com/s2/favicons?sz=64&domain=hoxhunt.com",
  "ideagen": "https://www.google.com/s2/favicons?sz=64&domain=ideagen.com",
  "ideo": "https://www.google.com/s2/favicons?sz=64&domain=ideo.com",
  "invision": "https://www.google.com/s2/favicons?sz=64&domain=invision.com",
  "jobadder": "https://www.google.com/s2/favicons?sz=64&domain=jobadder.com",
  "jobvite": "https://www.google.com/s2/favicons?sz=64&domain=jobvite.com",
  "jostle": "https://www.google.com/s2/favicons?sz=64&domain=jostle.com",
  "junojourney": "https://www.google.com/s2/favicons?sz=64&domain=junojourney.com",
  "keeper": "https://www.google.com/s2/favicons?sz=64&domain=keepersecurity.com",
  "kpifire": "https://www.google.com/s2/favicons?sz=64&domain=kpifire.com",
  "lastpass": "https://www.google.com/s2/favicons?sz=64&domain=lastpass.com",
  "lattice": "https://www.google.com/s2/favicons?sz=64&domain=lattice.com",
  "latticeflowai": "https://www.google.com/s2/favicons?sz=64&domain=latticeflowai.com",
  "launchdarkly": "https://www.google.com/s2/favicons?sz=64&domain=launchdarkly.com",
  "leapsome": "https://www.google.com/s2/favicons?sz=64&domain=leapsome.com",
  "lever": "https://www.google.com/s2/favicons?sz=64&domain=lever.co",
  "logicgate": "https://www.google.com/s2/favicons?sz=64&domain=logicgate.com",
  "loom": "https://www.google.com/s2/favicons?sz=64&domain=loom.com",
  "looop": "https://www.google.com/s2/favicons?sz=64&domain=looop.com",
  "lucid": "https://www.google.com/s2/favicons?sz=64&domain=lucid.com",
  "appaegis": "https://www.google.com/s2/favicons?sz=64&domain=appaegis.com",
  "maptician": "https://www.google.com/s2/favicons?sz=64&domain=maptician.com",
  "metapulse": "https://www.google.com/s2/favicons?sz=64&domain=metapulse.com",
  "mindtickle": "https://www.google.com/s2/favicons?sz=64&domain=mindtickle.com",
  "miro": "https://www.google.com/s2/favicons?sz=64&domain=miro.com",
  "mixpanel": "https://www.google.com/s2/favicons?sz=64&domain=mixpanel.com",
  "mode": "https://www.google.com/s2/favicons?sz=64&domain=mode.com",
  "multiplier": "https://www.google.com/s2/favicons?sz=64&domain=usemultiplier.com",
  "mypolicies": "https://www.google.com/s2/favicons?sz=64&domain=mypolicies.com",
  "nordpass": "https://www.google.com/s2/favicons?sz=64&domain=nordpass.com",
  "openai": "https://www.google.com/s2/favicons?sz=64&domain=openai.com",
  "opsbook": "https://www.google.com/s2/favicons?sz=64&domain=opsbook.com",
  "opsgenie1f68e": "https://www.google.com/s2/favicons?sz=64&domain=opsgenie.com",
  "opslevel": "https://www.google.com/s2/favicons?sz=64&domain=opslevel.com",
  "osano": "https://www.google.com/s2/favicons?sz=64&domain=osano.com",
  "parsable": "https://www.google.com/s2/favicons?sz=64&domain=parsable.com",
  "peakon": "https://www.google.com/s2/favicons?sz=64&domain=peakon.com",
  "peripass": "https://www.google.com/s2/favicons?sz=64&domain=peripass.com",
  "phalanx": "https://www.google.com/s2/favicons?sz=64&domain=phalanx.com",
  "pipedrive": "https://www.google.com/s2/favicons?sz=64&domain=pipedrive.com",
  "postman": "https://www.google.com/s2/favicons?sz=64&domain=postman.com",
  "prioritymatrix": "https://www.google.com/s2/favicons?sz=64&domain=prioritymatrix.com",
  "probackupbv": "https://www.google.com/s2/favicons?sz=64&domain=probackupbv.com",
  "prodpad": "https://www.google.com/s2/favicons?sz=64&domain=prodpad.com",
  "productboard": "https://www.google.com/s2/favicons?sz=64&domain=productboard.com",
  "qlik": "https://www.google.com/s2/favicons?sz=64&domain=qlik.com",
  "ramp": "https://www.google.com/s2/favicons?sz=64&domain=ramp.com",
  "ravenna": "https://www.google.com/s2/favicons?sz=64&domain=ravenna.com",
  "reportit": "https://www.google.com/s2/favicons?sz=64&domain=reportit.com",
  "rfpio": "https://www.google.com/s2/favicons?sz=64&domain=rfpio.com",
  "retool": "https://www.google.com/s2/favicons?sz=64&domain=retool.com",
  "robin": "https://www.google.com/s2/favicons?sz=64&domain=robin.com",
  "rockset": "https://www.google.com/s2/favicons?sz=64&domain=rockset.com",
  "rollbar": "https://www.google.com/s2/favicons?sz=64&domain=rollbar.com",
  "scaleai": "https://www.google.com/s2/favicons?sz=64&domain=scale.com",
  "securily": "https://www.google.com/s2/favicons?sz=64&domain=securily.com",
  "segment": "https://www.google.com/s2/favicons?sz=64&domain=segment.com",
  "shopify": "https://www.google.com/s2/favicons?sz=64&domain=shopify.com",
  "sigma": "https://www.google.com/s2/favicons?sz=64&domain=sigmacomputing.com",
  "simplebackups": "https://www.google.com/s2/favicons?sz=64&domain=simplebackups.com",
  "slab": "https://www.google.com/s2/favicons?sz=64&domain=slab.com",
  "smartfile": "https://www.google.com/s2/favicons?sz=64&domain=smartfile.com",
  "smartrecruiters": "https://www.google.com/s2/favicons?sz=64&domain=smartrecruiters.com",
  "sophos": "https://www.google.com/s2/favicons?sz=64&domain=sophos.com",
  "sparkhire": "https://www.google.com/s2/favicons?sz=64&domain=sparkhire.com",
  "speakupnow": "https://www.google.com/s2/favicons?sz=64&domain=speakupnow.com",
  "splashtop": "https://www.google.com/s2/favicons?sz=64&domain=splashtop.com",
  "statsig": "https://www.google.com/s2/favicons?sz=64&domain=statsig.com",
  "subrosa": "https://www.google.com/s2/favicons?sz=64&domain=subrosa.com",
  "supabase": "https://www.google.com/s2/favicons?sz=64&domain=supabase.com",
  "sym": "https://www.google.com/s2/favicons?sz=64&domain=sym.com",
  "tailscale": "https://www.google.com/s2/favicons?sz=64&domain=tailscale.com",
  "talentech": "https://www.google.com/s2/favicons?sz=64&domain=talentech.com",
  "teamtailor": "https://www.google.com/s2/favicons?sz=64&domain=teamtailor.com",
  "termius": "https://www.google.com/s2/favicons?sz=64&domain=termius.com",
  "timetoreply": "https://www.google.com/s2/favicons?sz=64&domain=timetoreply.com",
  "torq": "https://www.google.com/s2/favicons?sz=64&domain=torq.com",
  "travelperk": "https://www.google.com/s2/favicons?sz=64&domain=travelperk.com",
  "trelica": "https://www.google.com/s2/favicons?sz=64&domain=trelica.com",
  "tribeloo": "https://www.google.com/s2/favicons?sz=64&domain=tribeloo.com",
  "twingate": "https://www.google.com/s2/favicons?sz=64&domain=twingate.com",
  "unifi": "https://www.google.com/s2/favicons?sz=64&domain=unifi.com",
  "vendr": "https://www.google.com/s2/favicons?sz=64&domain=vendr.com",
  "vonage": "https://www.google.com/s2/favicons?sz=64&domain=vonage.com",
  "webex": "https://www.google.com/s2/favicons?sz=64&domain=webex.com",
  "whimsical": "https://www.google.com/s2/favicons?sz=64&domain=whimsical.com",
  "workplace": "https://www.google.com/s2/favicons?sz=64&domain=workplace.com",
  "xero": "https://www.google.com/s2/favicons?sz=64&domain=xero.com",
  "zapier": "https://www.google.com/s2/favicons?sz=64&domain=zapier.com",
  "zavanta": "https://www.google.com/s2/favicons?sz=64&domain=zavanta.com",
  "zero": "https://www.google.com/s2/favicons?sz=64&domain=zero.com",
  "zip": "https://www.google.com/s2/favicons?sz=64&domain=zip.com",
  "zoominfo": "https://www.google.com/s2/favicons?sz=64&domain=zoominfo.com",
  "360learning": "https://www.google.com/s2/favicons?sz=64&domain=360learning.com",
  "adaptivesecurity": "https://www.google.com/s2/favicons?sz=64&domain=adaptivesecurity.com",
  "awarego": "https://www.google.com/s2/favicons?sz=64&domain=awarego.com",
  "caniphish": "https://www.google.com/s2/favicons?sz=64&domain=caniphish.com",
  "cybeready": "https://www.google.com/s2/favicons?sz=64&domain=cybeready.com",
  "cyberly": "https://www.google.com/s2/favicons?sz=64&domain=cyberly.com",
  "easyllama": "https://www.google.com/s2/favicons?sz=64&domain=easyllama.com",
  "elba": "https://www.google.com/s2/favicons?sz=64&domain=elba.com",
  "ethena": "https://www.google.com/s2/favicons?sz=64&domain=ethena.com",
  "ghosteye": "https://www.google.com/s2/favicons?sz=64&domain=ghosteye.com",
  "haekka": "https://www.google.com/s2/favicons?sz=64&domain=haekka.com",
  "hooksecurity": "https://www.google.com/s2/favicons?sz=64&domain=hooksecurity.com",
  "curricula": "https://www.google.com/s2/favicons?sz=64&domain=huntress.com",
  "kamae": "https://www.google.com/s2/favicons?sz=64&domain=kamae.com",
  "knowbe4": "https://www.google.com/s2/favicons?sz=64&domain=knowbe4.com",
  "moxso": "https://www.google.com/s2/favicons?sz=64&domain=moxso.com",
  "ninjio": "https://www.google.com/s2/favicons?sz=64&domain=ninjio.com",
  "outkept": "https://www.google.com/s2/favicons?sz=64&domain=outkept.com",
  "outthink": "https://www.google.com/s2/favicons?sz=64&domain=outthink.com",
  "ransomleak": "https://www.google.com/s2/favicons?sz=64&domain=ransomleak.com",
  "riot": "https://www.google.com/s2/favicons?sz=64&domain=riot.com",
  "safestack": "https://www.google.com/s2/favicons?sz=64&domain=safestack.com",
  "smartfense": "https://www.google.com/s2/favicons?sz=64&domain=smartfense.com",
  "sosafe": "https://www.google.com/s2/favicons?sz=64&domain=sosafe.com",
  "talentlms": "https://www.google.com/s2/favicons?sz=64&domain=talentlms.com",
  "vansec": "https://www.google.com/s2/favicons?sz=64&domain=vansec.com",
  "wizer": "https://www.google.com/s2/favicons?sz=64&domain=wizer.com",
  "aha": "https://www.google.com/s2/favicons?sz=64&domain=aha.com",
  "asana": "https://www.google.com/s2/favicons?sz=64&domain=asana.com",
  "basecamp": "https://www.google.com/s2/favicons?sz=64&domain=basecamp.com",
  "clickup": "https://www.google.com/s2/favicons?sz=64&domain=clickup.com",
  "dixa": "https://www.google.com/s2/favicons?sz=64&domain=dixa.com",
  "freshdesk": "https://www.google.com/s2/favicons?sz=64&domain=freshworks.com",
  "freshservice": "https://www.google.com/s2/favicons?sz=64&domain=freshworks.com",
  "front": "https://www.google.com/s2/favicons?sz=64&domain=front.com",
  "githubissues": "https://www.google.com/s2/favicons?sz=64&domain=github.com",
  "gitlabissues": "https://www.google.com/s2/favicons?sz=64&domain=gitlab.com",
  "gitlabissuesonprem": "https://www.google.com/s2/favicons?sz=64&domain=gitlab.com",
  "gladly": "https://www.google.com/s2/favicons?sz=64&domain=gladly.com",
  "gorgias": "https://www.google.com/s2/favicons?sz=64&domain=gorgias.com",
  "height": "https://www.google.com/s2/favicons?sz=64&domain=height.com",
  "helpscout": "https://www.google.com/s2/favicons?sz=64&domain=helpscout.com",
  "hive": "https://www.google.com/s2/favicons?sz=64&domain=hive.com",
  "humi": "https://www.google.com/s2/favicons?sz=64&domain=humi.com",
  "kustomer": "https://www.google.com/s2/favicons?sz=64&domain=kustomer.com",
  "linear": "https://www.google.com/s2/favicons?sz=64&domain=linear.app",
  "microsoftplanner": "https://www.google.com/s2/favicons?sz=64&domain=microsoft.com",
  "monday": "https://www.google.com/s2/favicons?sz=64&domain=monday.com",
  "pivotaltracker": "https://www.google.com/s2/favicons?sz=64&domain=pivotaltracker.com",
  "reamaze": "https://www.google.com/s2/favicons?sz=64&domain=reamaze.com",
  "shortcut": "https://www.google.com/s2/favicons?sz=64&domain=shortcut.com",
  "smartsheet": "https://www.google.com/s2/favicons?sz=64&domain=smartsheet.com",
  "spotdraft": "https://www.google.com/s2/favicons?sz=64&domain=spotdraft.com",
  "teamwork": "https://www.google.com/s2/favicons?sz=64&domain=teamwork.com",
  "trello": "https://www.google.com/s2/favicons?sz=64&domain=trello.com",
  "wrike": "https://www.google.com/s2/favicons?sz=64&domain=wrike.com",
  "youtrack": "https://www.google.com/s2/favicons?sz=64&domain=youtrack.com",
  "zohobugtracker": "https://www.google.com/s2/favicons?sz=64&domain=zohobugtracker.com",
  "zohodesk": "https://www.google.com/s2/favicons?sz=64&domain=zohodesk.com",
  "zohopeople": "https://www.google.com/s2/favicons?sz=64&domain=zohopeople.com",
  "awscodecommit": "https://www.google.com/s2/favicons?sz=64&domain=aws.amazon.com",
  "azuredevops": "https://www.google.com/s2/favicons?sz=64&domain=microsoft.com",
  "githubonprem": "https://www.google.com/s2/favicons?sz=64&domain=github.com",
  "gitlabonprem": "https://www.google.com/s2/favicons?sz=64&domain=gitlab.com",
  "13security": "https://www.google.com/s2/favicons?sz=64&domain=13security.com",
  "aftra": "https://www.google.com/s2/favicons?sz=64&domain=aftra.com",
  "aikido": "https://www.google.com/s2/favicons?sz=64&domain=aikido.com",
  "almanax": "https://www.google.com/s2/favicons?sz=64&domain=almanax.com",
  "astrasecurity": "https://www.google.com/s2/favicons?sz=64&domain=astrasecurity.com",
  "attackerview": "https://www.google.com/s2/favicons?sz=64&domain=attackerview.com",
  "awsguardduty": "https://www.google.com/s2/favicons?sz=64&domain=aws.amazon.com",
  "awsinspector": "https://www.google.com/s2/favicons?sz=64&domain=aws.amazon.com",
  "azuredefender": "https://www.google.com/s2/favicons?sz=64&domain=microsoft.com",
  "blacklocksecurity": "https://www.google.com/s2/favicons?sz=64&domain=blacklocksecurity.com",
  "botprise": "https://www.google.com/s2/favicons?sz=64&domain=botprise.com",
  "breachlock": "https://www.google.com/s2/favicons?sz=64&domain=breachlockinc.com",
  "capturethebug": "https://www.google.com/s2/favicons?sz=64&domain=capturethebug.com",
  "coana": "https://www.google.com/s2/favicons?sz=64&domain=coana.com",
  "cobalt": "https://www.google.com/s2/favicons?sz=64&domain=cobalt.io",
  "coguard": "https://www.google.com/s2/favicons?sz=64&domain=coguard.com",
  "contxt": "https://www.google.com/s2/favicons?sz=64&domain=contxt.com",
  "deepsource": "https://www.google.com/s2/favicons?sz=64&domain=deepsource.com",
  "edgebit": "https://www.google.com/s2/favicons?sz=64&domain=edgebit.com",
  "fencer": "https://www.google.com/s2/favicons?sz=64&domain=fencer.com",
  "gcpcontaineranalysis": "https://www.google.com/s2/favicons?sz=64&domain=cloud.google.com",
  "githubdependabot": "https://www.google.com/s2/favicons?sz=64&domain=github.com",
  "halosecurity": "https://www.google.com/s2/favicons?sz=64&domain=halosecurity.com",
  "heyhack": "https://www.google.com/s2/favicons?sz=64&domain=heyhack.com",
  "hostedscan": "https://www.google.com/s2/favicons?sz=64&domain=hostedscan.com",
  "intruder": "https://www.google.com/s2/favicons?sz=64&domain=intruder.com",
  "jitsecurity": "https://www.google.com/s2/favicons?sz=64&domain=jit.com",
  "lacework": "https://www.google.com/s2/favicons?sz=64&domain=lacework.com",
  "lumenovaai": "https://www.google.com/s2/favicons?sz=64&domain=lumenova.com",
  "defendergcchigh": "https://www.google.com/s2/favicons?sz=64&domain=microsoft.com",
  "defenderforcloud": "https://www.google.com/s2/favicons?sz=64&domain=microsoft.com",
  "orca": "https://www.google.com/s2/favicons?sz=64&domain=orca.com",
  "ostorlab": "https://www.google.com/s2/favicons?sz=64&domain=ostorlab.com",
  "panopticscans": "https://www.google.com/s2/favicons?sz=64&domain=panopticscans.com",
  "pentesttools": "https://www.google.com/s2/favicons?sz=64&domain=pentest-tools.com",
  "plerion": "https://www.google.com/s2/favicons?sz=64&domain=plerion.com",
  "prancer": "https://www.google.com/s2/favicons?sz=64&domain=prancer.com",
  "probely": "https://www.google.com/s2/favicons?sz=64&domain=probely.com",
  "qualys": "https://www.google.com/s2/favicons?sz=64&domain=qualys.com",
  "rapid7": "https://www.google.com/s2/favicons?sz=64&domain=rapid7.com",
  "sentinelone": "https://www.google.com/s2/favicons?sz=64&domain=sentinelone.com",
  "snyk": "https://www.google.com/s2/favicons?sz=64&domain=snyk.io",
  "socket": "https://www.google.com/s2/favicons?sz=64&domain=socket.com",
  "softwaresecured": "https://www.google.com/s2/favicons?sz=64&domain=softwaresecured.com",
  "soos": "https://www.google.com/s2/favicons?sz=64&domain=soos.com",
  "stackhawk": "https://www.google.com/s2/favicons?sz=64&domain=stackhawk.com",
  "strikesecurity": "https://www.google.com/s2/favicons?sz=64&domain=strikesecurity.com",
  "tenablevulnmgmt": "https://www.google.com/s2/favicons?sz=64&domain=tenable.com",
  "threatmate": "https://www.google.com/s2/favicons?sz=64&domain=threatmate.com",
  "trava": "https://www.google.com/s2/favicons?sz=64&domain=trava.com",
  "wiz": "https://www.google.com/s2/favicons?sz=64&domain=wiz.io",
  "wizforgoverment": "https://www.google.com/s2/favicons?sz=64&domain=wiz.io",

};

const DISPLAY_NAME = {
  aws: 'AWS', gcp: 'GCP', azure: 'Azure', github: 'GitHub', jira: 'Jira',
  gitlab: 'GitLab', kubernetes: 'Kubernetes', datadog: 'Datadog', okta: 'Okta',
  snowflake: 'Snowflake', splunk: 'Splunk', pagerduty: 'PagerDuty',
  bitbucket: 'Bitbucket', digitalocean: 'DigitalOcean', newrelic: 'New Relic',
  cloudflare: 'Cloudflare', sentry: 'Sentry',
  crowdstrike: 'CrowdStrike', microsoft: 'Microsoft 365', servicenow: 'ServiceNow',
  slack: 'Slack', googleworkspace: 'Google Workspace', onelogin: 'OneLogin',
  jumpcloud: 'JumpCloud', duo: 'Cisco Duo', pingone: 'Ping Identity',
  auth0: 'Auth0', jamf: 'Jamf Pro', intune: 'Microsoft Intune', kandji: 'Kandji',
  clerk: 'Clerk', postmark: 'Postmark',
};

/* Which vendors have discoverable assets and how to read the counts */
const ASSET_CONFIG = {
  aws:    { labelKey: 'assetLabelAws',          icon: 'fa-server',      color: '#FF9900' },
  gcp:    { labelKey: 'assetLabelGcp',          icon: 'fa-cloud',       color: '#4285F4' },
  azure:  { labelKey: 'assetLabelAzure',        icon: 'fa-cloud',       color: '#0078D4' },
  github: { labelKey: 'assetLabelRepositories', icon: 'fa-code-branch', color: '#181717' },
};

function fmtDate(d) {
  if (!d) return null;
  return new Date(d).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });
}

function VendorOverviewPage() {
  const { t } = useTranslation();
  const { vendorName } = useParams();
  const navigate = useNavigate();
  const vendorKey = vendorName?.toLowerCase();

  const [connection, setConnection] = useState(null);
  const [assetData, setAssetData]   = useState(null);
  const [loading, setLoading]       = useState(true);
  const [disconnecting, setDisconnecting] = useState(false);
  const [syncing, setSyncing]       = useState(false);
  const [syncMsg, setSyncMsg]       = useState(null);
  const [error, setError]           = useState(null);

  const displayName = DISPLAY_NAME[vendorKey] || vendorName;
  const logoUrl     = VENDOR_LOGOS[vendorKey];
  const assetConf   = ASSET_CONFIG[vendorKey];

  useEffect(() => {
    const load = async () => {
      try {
        const [connRes, countsRes] = await Promise.all([
          axiosInstance.get('/vendors/connections'),
          axiosInstance.get('/discovered-assets/counts').catch(() => ({ data: {} })),
        ]);

        const conn = (connRes.data || []).find(
          c => c.vendorType?.toLowerCase() === vendorKey
        );
        setConnection(conn || null);
        // Per-provider asset counts from the real discovered-asset inventory (the SAME source as
        // the Vendors list + Assets page), keyed case-insensitively by provider — so the detail
        // count matches the list (e.g. GitHub 25, Azure 18) instead of the stale /assets summary.
        const byProvider = {};
        Object.entries((countsRes.data && countsRes.data.byCloudProvider) || {}).forEach(
          ([name, count]) => { byProvider[String(name).toLowerCase()] = count; }
        );
        setAssetData(byProvider);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [vendorKey]);

  const handleSync = async () => {
    if (!connection) return;
    setSyncing(true);
    setError(null);
    setSyncMsg(null);
    try {
      // Org-admin self-service discovery — the org's own compliance lead runs it, no partner needed.
      const res = await axiosInstance.post(`/vendors/connections/${connection.id}/sync`);
      const d = res.data || {};
      const total = (d.totalResources != null) ? d.totalResources
                  : (d.discovered != null) ? d.discovered : null;
      setSyncMsg(total != null
        ? t('VendorOverviewPage.syncSuccess', { defaultValue: 'Discovered {{count}} resource(s).', count: total })
        : (d.message || t('VendorOverviewPage.syncDone', { defaultValue: 'Sync complete.' })));
      // Refresh the connection so Last Synced updates.
      const connRes = await axiosInstance.get('/vendors/connections');
      const fresh = (connRes.data || []).find(c => c.vendorType?.toLowerCase() === vendorKey);
      if (fresh) setConnection(fresh);
    } catch (err) {
      setError(t('VendorOverviewPage.syncError', {
        defaultValue: 'Discovery failed: {{message}}',
        message: err.response?.data?.message || err.message,
      }));
    } finally {
      setSyncing(false);
    }
  };

  const handleDisconnect = async () => {
    if (!connection) return;
    if (!window.confirm(t('VendorOverviewPage.disconnectConfirm', { name: displayName }))) return;
    setDisconnecting(true);
    try {
      await axiosInstance.delete(`/vendors/connections/${connection.id}`);
      navigate('/dashboard/vendors');
    } catch (err) {
      setError(t('VendorOverviewPage.disconnectError', { message: err.response?.data?.message || err.message }));
      setDisconnecting(false);
    }
  };

  if (loading) return <div className="vo-loading"><div className="vo-spinner" /></div>;

  const statusColor = connection?.status === 'ACTIVE' ? '#16a34a' : '#dc2626';
  const statusBg    = connection?.status === 'ACTIVE' ? '#f0fdf4' : '#fef2f2';
  // Count comes from the real discovered-asset inventory (assetData is now a provider→count map).
  const assetCount  = assetData && assetData[vendorKey] != null
    ? assetData[vendorKey]
    : (assetConf ? 0 : null);

  return (
    <div className="vo-page">
      {error && <div className="vo-error">{error}</div>}
      {syncMsg && <div className="vo-success" style={{ background: '#f0fdf4', color: '#166534', padding: '10px 14px', borderRadius: 8, marginBottom: 12 }}>
        <i className="fas fa-check-circle" /> {syncMsg}
      </div>}

      {/* Header */}
      <div className="vo-header-card">
        <div className="vo-header-left">
          <button className="vo-back" onClick={() => navigate('/dashboard/vendors')}>
            <i className="fas fa-arrow-left" /> {t('VendorOverviewPage.backToVendors')}
          </button>
          <div className="vo-title-row">
            <div className="vo-logo-wrap">
              {logoUrl
                ? <img src={logoUrl} alt={displayName} className="vo-logo"
                    onError={e => { e.currentTarget.style.display = 'none'; }} />
                : <div className="vo-logo-initial">{displayName.charAt(0).toUpperCase()}</div>
              }
            </div>
            <div>
              <h1 className="vo-vendor-name">{displayName}</h1>
              {connection && (
                <span className="vo-status-badge" style={{ color: statusColor, background: statusBg }}>
                  <i className={`fas fa-${connection.status === 'ACTIVE' ? 'check-circle' : 'times-circle'}`} />
                  {connection.status}
                </span>
              )}
            </div>
          </div>
        </div>

        <div className="vo-header-actions">
          {connection && (
            <button
              className="vo-btn-primary"
              onClick={handleSync}
              disabled={syncing}
            >
              <i className={`fas fa-sync-alt ${syncing ? 'fa-spin' : ''}`} />
              {syncing
                ? t('VendorOverviewPage.syncing', { defaultValue: 'Discovering…' })
                : t('VendorOverviewPage.syncAssets', { defaultValue: 'Discover Assets' })}
            </button>
          )}
          {integrationDocsUrl(vendorKey) && (
            <a className="vo-btn-secondary" href={integrationDocsUrl(vendorKey)} target="_blank" rel="noopener noreferrer">
              <i className="fas fa-book" /> {t('VendorDetailsPage.integrationDocs')}
            </a>
          )}
          <button
            className="vo-btn-secondary"
            onClick={() => navigate(`/dashboard/vendors/cards/${vendorKey}`)}
          >
            <i className="fas fa-edit" /> {t('VendorOverviewPage.updateCredentials')}
          </button>
          {connection && (
            <button
              className="vo-btn-danger"
              onClick={handleDisconnect}
              disabled={disconnecting}
            >
              <i className="fas fa-unlink" />
              {disconnecting ? t('VendorOverviewPage.disconnecting') : t('VendorOverviewPage.disconnect')}
            </button>
          )}
        </div>
      </div>

      <div className="vo-body">
        {/* Connection details */}
        <div className="vo-card">
          <div className="vo-card-title">{t('VendorOverviewPage.connectionDetails')}</div>
          <div className="vo-meta-grid">
            <div className="vo-meta-item">
              <span className="vo-meta-label">{t('VendorOverviewPage.statusLabel')}</span>
              <span className="vo-meta-val">
                {connection
                  ? <span style={{ color: statusColor, fontWeight: 600 }}>{connection.status}</span>
                  : <span className="vo-dim">{t('VendorOverviewPage.legacyConnection')}</span>}
              </span>
            </div>
            <div className="vo-meta-item">
              <span className="vo-meta-label">{t('VendorOverviewPage.connectedLabel')}</span>
              <span className="vo-meta-val">
                {fmtDate(connection?.createdAt) || <span className="vo-dim">—</span>}
              </span>
            </div>
            <div className="vo-meta-item">
              <span className="vo-meta-label">{t('VendorOverviewPage.lastSyncedLabel')}</span>
              <span className="vo-meta-val">
                {fmtDate(connection?.lastSyncedAt) || <span className="vo-dim">{t('VendorOverviewPage.never')}</span>}
              </span>
            </div>
            {connection?.accountType && (
              <div className="vo-meta-item">
                <span className="vo-meta-label">{t('VendorOverviewPage.accountTypeLabel')}</span>
                <span className="vo-meta-val">{connection.accountType}</span>
              </div>
            )}
          </div>
        </div>

        {/* Assets */}
        <div className="vo-card">
          <div className="vo-card-title">{t('VendorOverviewPage.discoveredAssets')}</div>
          {assetConf ? (
            <div className="vo-asset-stat">
              <div className="vo-asset-icon"
                style={{ background: assetConf.color + '15', color: assetConf.color }}>
                <i className={`fas ${assetConf.icon}`} />
              </div>
              <div>
                <div className="vo-asset-count">{assetCount.toLocaleString()}</div>
                <div className="vo-asset-label">{t(`VendorOverviewPage.${assetConf.labelKey}`)}</div>
              </div>
            </div>
          ) : (
            <div className="vo-no-assets">
              <i className="fas fa-sync-alt" />
              <p>{t('VendorOverviewPage.noAssets', { name: displayName })}</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default VendorOverviewPage;
